import { styleTips } from '@/mocks/styleGuide';

export default function StyleTips() {
  return (
    <section className="bg-[#1E1610] py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="font-sans text-[1rem] text-yellow-200/60 tracking-widest mb-3 font-light">
            STYLING TIPS
          </p>
          <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-white font-semibold leading-[1.4]">
            造型師的四大穿搭心法
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {styleTips.map((tip) => (
            <div
              key={tip.id}
              className="bg-white/6 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-900/40 rounded-xl mb-5">
                <i className={`${tip.icon} text-yellow-300 text-2xl`}></i>
              </div>
              <h3 className="font-serif text-[1.1875rem] text-white font-semibold mb-3 leading-[1.5]">
                {tip.title}
              </h3>
              <p className="font-sans text-[1rem] text-white/60 leading-[1.75]">
                {tip.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
